import { ExpandedTooltip } from '@livable/saas-react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BalanceStatus } from 'src/components/general/BalanceStatus';
import RippleEffect from 'src/components/general/RippleEffect';
import { useStore } from 'src/stores';
import useStyles from '../styles';
const BalanceCell = _ref => {
  var _params$row, _params$row2, _params$row3;
  let params = _ref.params;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const getTooltipContent = () => {
    switch (params.row.balanceStatus) {
      case 'Due':
        {
          var _store$payment$billin;
          const days = (_store$payment$billin = store.payment.billingSchedule.find(i => i.billingScheduleEvent === 'LateFeeAssessment')) === null || _store$payment$billin === void 0 ? void 0 : _store$payment$billin.remainingDays;
          return {
            title: days > 0 ? t("residencies_page.late_in", {
              days,
              s: days > 1 ? 's' : ''
            }) : t('residencies_page.due_approaching'),
            type: 'warning'
          };
        }
      case 'Ok':
        return {
          title: t('residencies_page.balance_ok'),
          type: 'success'
        };
      case 'Overdue':
        return {
          title: t('residencies_page.balance_overdue'),
          type: 'error'
        };
      default:
        return {};
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, params.row.vacant ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.disabledCellText, " ").concat(classes.flex)
  }, "N/A") : /*#__PURE__*/React.createElement(React.Fragment, null, (_params$row = params.row) !== null && _params$row !== void 0 && _params$row.balanceStatus ? /*#__PURE__*/React.createElement(ExpandedTooltip, {
    hideOnMobile: true,
    placement: "top",
    title: getTooltipContent().title,
    type: getTooltipContent().type
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tooltipContent
  }, /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat((_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
  }, params.row.balance, /*#__PURE__*/React.createElement(BalanceStatus, {
    status: params.row.balanceStatus,
    hideText: true
  })))) : /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat((_params$row3 = params.row) !== null && _params$row3 !== void 0 && _params$row3.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
  }, params.row.balance)));
};
export default BalanceCell;